// extracted by mini-css-extract-plugin
export default {"server":"Server-server_KGB9W","specifications":"Server-specifications_mtqd1"};